module.exports = __webpack_public_path__ + "img/2.4ebd80b9.jpg";